/** @module AQL/SizeChart/BatchSectionSamplesTable */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Delete",
	"csi/def/Actions",
	"csi/store/Nodes",
	"csi/table/Delete",
	"csi/table/_GroupByRefMixin",
	"csi/table/Preferences",
	"csi/xml",
	"ProductSpec/SizeChart",
	"ProductSpec/SizeChart/CustomViewSizeChartOptions",
	"ProductSpec/SizeChart/SizeChartTableCustomViewOptionsStore",
	"ProductSpec/SizeChart/SizeChartTableOptionsTab",
	"ProductSpec/SizeChart/Table"
], function(declare, lang, Delete, Actions, Nodes, DeleteController, _GroupByRefMixin, Preferences, xml, SizeChart, {SizeChartDimensionFormatType}, SizeChartTableCustomViewOptionsStore, SizeChartTableOptionsTab, Table) {

	const _Preferences = declare(Preferences, {
		constructor: function() {
			this.addCustomOption("sizeChartUnits", SizeChart.valueUnits, false, "SizeChartUnits");
			this.addCustomOption("sizeChartDimensionFormat", SizeChartDimensionFormatType.DEFAULT, false, "SizeChartDimensionFormat");
		}
	});

	const _DeleteSectionController = declare(DeleteController, {
		/**
		 * @override
		 * Set group url
		 */
		toWriter: function() {
			const url = this.m_urlNode;
			var groupURL = this._getGroupURL();
			if (xml.isValidURL(groupURL)) {
				this.m_urlNode = groupURL;
			}
			this.inherited(arguments);
			this.m_urlNode = url;
		}
	});

	return declare([Table, _GroupByRefMixin], {
		prefClass: _Preferences,
		groupByRefAttr: xml.ATTR_PARENT,

		customViewOptionsComponent: SizeChartTableOptionsTab,
		customViewOptionsStore: SizeChartTableCustomViewOptionsStore,

		// Do not disable New action if no groups exist.
		bDisableNewActionIfNoGroups: false,

		/**
		 * @override
		 * Configure query level for group
		 * @param {Level} ql
		 */
		onGroupByRefQueryLevel: function(ql) {
			const sections = this.cacheView.getNodes(this.getViewNode().Samples);
			const store = new Nodes({
				data: sections
			});

			ql.actions = lang.mixin(new Actions(), {
				m_actions: [lang.mixin(new Delete(), {
					classController: _DeleteSectionController
				})]
			});
			ql.groupDefaultsStore = store;
		},
	});
});